import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  max-width: 1360px;
  margin: 0 auto -11px;
`

const Content = () => {
  const videoRef = useRef(null)

  useEffect(() => {
    const { current: videoElement } = videoRef
    videoElement.setAttribute('muted', '')
    videoElement.setAttribute('playsinline', '')
    videoElement.setAttribute('autoplay', '')
    videoElement.play()
  }, [])

  return (
    <Wrapper>
      <video
        width="100%"
        height="100%"
        preload="auto"
        muted
        loop
        playsInLine
        ref={videoRef}
        id="career-video"
      >
        <source
          src="https://media.auto.works/original/3d8d00af4562e3cc85696380a4f2d801:770036d91adbc771f4ca92d6f281b7ec"
          type="video/mp4"
        />
      </video>
    </Wrapper>
  )
}

export default Content
